import type { PredictionMarketWithProbability } from "@roman/shared/types/PredictionMarket";
import { createMarketShareUrl } from "@roman/shared/utils/predictionMarket/createMarketShareUrl";

export const handleShare = (market: PredictionMarketWithProbability) => {
  if (navigator.share) {
    navigator.share({
      title: market.title,
      url: createMarketShareUrl(market.id),
    });
  } else {
    // Fallback: copy to clipboard
    const url = createMarketShareUrl(market.id);
    navigator.clipboard
      .writeText(url)
      .then(() => {
        window.alert("URLをクリップボードにコピーしました！");
      })
      .catch(() => {
        window.alert("Sharing is not supported on this device.");
      });
  }
};
